/**
 * **메뉴의 법정 표기·태그 칸 — 원산지 표기 · 알레르기 표기 · 메뉴 태그.** 의존성 없는 순수 모듈이다(Vue·`@/` 별칭 금지).
 *
 * 칸을 그리는 곳은 `components/store/SmenuLabelingPanel.vue` 하나이고, 점주 「메뉴 관리」(`SMenuListForStoreView`)와
 * 사업장 관리자·관리점·운영사의 「메뉴 관리」(`SMenuListView`)가 함께 쓴다. 7월(`a9724d6`)에 점주 화면에만 칸이 생겨
 * 대행 계정은 메뉴 원산지를 입력할 수 없었다(R-S). 이 파일은 두 화면의 빈 폼과 빈 오류 칸이 **같은 키**를 갖게 한다.
 *
 * 저장은 각 화면의 메뉴 저장 본문 그대로다(점주 `PUT /smenu/store/{cd}` · 사업장·대행 `PUT /smenu/{cd}`) — 서버 엔티티의
 * 같은 이름 칸(`Smenu.originLabeling`·`allergenInfo`·`menuTags`)이고 메뉴 상세 응답에 실려 온다.
 */

/** 칸 이름 — 서버 JSON 의 칸 이름과 같다 */
export const SMENU_LABELING_KEYS = Object.freeze(['originLabeling', 'allergenInfo', 'menuTags'])

/**
 * 빈 칸 묶음(새 객체) — 등록 폼의 값과 오류 칸이 같은 모양이다(모두 빈 문자열).
 *
 * @returns {{originLabeling: string, allergenInfo: string, menuTags: string}}
 */
export function smenuLabelingBlank() {
  return SMENU_LABELING_KEYS.reduce((blank, key) => Object.assign(blank, { [key]: '' }), {})
}
